<div class="mobile-product-detail bg-white min-h-screen">
  <!-- Loading Spinner -->
  <nz-spin [nzSpinning]="isDetailLoading" nzTip="加载中...">
    <!-- 1. Product Information Card (Top Section) -->
    <div class="product-header px-4 pt-4 pb-2">
      <!-- Error Report (Floating Top Right) (click)="showErrorReportModal()"-->
      <div class="flex justify-end mb-2" (click)="showErrorReportModal()" *ngIf="isReportErrorVisible">
        <div class="inline-flex items-center gap-1 cursor-pointer">
          <i
            nz-icon
            nzType="exclamation-circle"
            nzTheme="outline"
            class="text-[#007BC0] text-sm"
          ></i>
          <span class="text-[#007BC0] text-[14px]">匹配报错</span>
        </div>
      </div>

      <div class="bg-[#F4F6F8] p-4">
        <div class="flex gap-4 items-start">
          <!-- Product Image (With Gray Background) -->
          <div
            class="product-image-box w-28 h-28 flex-shrink-0 bg-gray-50 rounded-lg flex items-center justify-center p-2 border border-gray-100"
          >
            <img
              [src]="getImage(imageList)"
              alt="Product"
              (click)="previewCurrentImage()"
              class="w-full h-full object-contain mix-blend-multiply cursor-zoom-in"
            />
          </div>

          <!-- Product Details -->
          <div class="flex-1 min-w-0 flex flex-col justify-center py-1">
            <h2
              class="text-base font-bold text-gray-900 mb-2 leading-snug line-clamp-2"
            >
              {{ productData?.partName }}
            </h2>

            <div class="flex items-center gap-2 mb-3">
              <span
                class="text-[#007BC0] text-base font-medium font-mono"
                (click)="copyProductCode()"
              >
                {{ productData?.partNo }}
              </span>
              <i
                nz-icon
                nzType="copy"
                nzTheme="outline"
                class="text-[#007BC0] text-sm cursor-pointer"
                (click)="copyProductCode()"
              ></i>
            </div>

            <!-- Replacement Numbers -->
            <div class="text-xs text-gray-500 space-y-1">
              <div
                *ngIf="partVOList[0]?.previousPartList?.length > 0"
                class="flex items-start"
              >
                <span class="mr-1 flex-shrink-0">前序:</span>
                <span class="break-all line-clamp-1">
                  <ng-container
                    *ngFor="
                      let item of partVOList[0]?.previousPartList;
                      let isLast = last
                    "
                  >
                    {{ item.partNo }}{{ !isLast ? "/" : "" }}
                  </ng-container>
                </span>
              </div>
              <div
                *ngIf="partVOList[0]?.successorPartList?.length > 0"
                class="flex items-start"
              >
                <span class="mr-1 flex-shrink-0">后序:</span>
                <span class="break-all line-clamp-1">
                  <ng-container
                    *ngFor="
                      let item of partVOList[0]?.successorPartList;
                      let isLast = last
                    "
                  >
                    {{ item.partNo }}{{ !isLast ? "/" : "" }}
                  </ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Disclaimer -->
        <div
          class="mt-2 p-2 text-[10px] text-[#595E62] bg-[#E0E2E5] rounded-md"
        >
          *{{ getImageDescription() }}
        </div>
      </div>
    </div>

    <!-- Divider -->
    <div class="h-2 bg-gray-50 w-full"></div>

    <!-- 2. Tabs Navigation -->
    <div class="sticky top-0 z-20 bg-white border-b border-gray-100">
      <div class="flex overflow-x-auto no-scrollbar">
        <div
          *ngFor="
            let tab of [
              '技术参数',
              '适配车型',
              '原厂信息'
            ];
            let i = index
          "
          class="relative flex-shrink-0 px-5 py-3 text-sm font-medium transition-all duration-300 cursor-pointer"
          [class.text-primary]="activeTab === i"
          [class.text-gray-600]="activeTab !== i"
          [class.font-bold]="activeTab === i"
          (click)="activeTab = i"
        >
          {{ tab }}
          <!-- Active Indicator Line -->
          <div
            *ngIf="activeTab === i"
            class="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-0.5 bg-[#007BC0] rounded-full"
          ></div>
        </div>
      </div>
    </div>

    <!-- 3. Tab Content -->
    <div class="px-4 py-2 min-h-[300px]">
      <!-- Tab 0: Technical Parameters (Style matching Image 4) -->
      <div *ngIf="activeTab === 0" class="animate-fade-in">
        <div class="divide-y divide-gray-100">
          <div
            *ngFor="let item of processData(productData)"
            class="flex justify-between items-center py-4"
          >
            <span class="text-sm text-gray-500 flex-shrink-0 mr-4">{{
              item.featureNameCn
            }}</span>
            <div
              class="text-sm text-gray-900 font-medium text-right flex-1 break-words"
            >
              <!-- Special Handling for Icons -->
              <span
                *ngIf="item.featureNameCn === '每套个数'"
                class="inline-flex items-center justify-end"
              >
                {{ item.featureValue }}
              </span>
              <!-- Standard Value Display -->
              <span *ngIf="item.featureNameCn !== '每套个数'">
                <!-- Handle specific length rounding logic as per your request -->
                <ng-container
                  *ngIf="(productData?.category1Name?.includes('雨刮')) &&
                    [
                      '长度 1（英寸）',
                      '长度 2（英寸）',
                      '雨刮1长度',
                      '雨刮2长度(仅套装)',
                      '长度 1',
                      '长度 2'
                    ].includes(item.featureNameCn);
                    else normalVal
                  "
                >
                  {{ Math.round(parseFloat(item.featureValue)) }}
                  <span
                    class="text-gray-400 font-normal ml-0.5"
                    *ngIf="item.featureUnit"
                    >{{ item.featureUnit }}</span
                  >
                </ng-container>
                <ng-template #normalVal>
                  {{ item.featureValueString || item.featureValue }}
                  <span
                    class="text-gray-400 font-normal ml-0.5"
                    *ngIf="!item.featureValueString && item.featureUnit"
                    >{{ item.featureUnit }}</span
                  >
                </ng-template>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab 1: Compatible Vehicles (Style matching Image 3) -->
      <div *ngIf="activeTab === 1" class="animate-fade-in">
        <div *ngFor="let brand of getBrands()" class="mb-4">
          <!-- Brand Header -->
          <div
            class="flex items-center justify-between py-3 px-1 bg-white cursor-pointer select-none"
            (click)="toggleBrand(brand)"
          >
            <span class="text-base font-bold text-gray-900">{{ brand }}</span>
            <i
              nz-icon
              [nzType]="isBrandExpanded(brand) ? 'up' : 'down'"
              nzTheme="outline"
              class="text-gray-400 text-sm"
            ></i>
          </div>

          <!-- Vehicles List -->
          <div *ngIf="isBrandExpanded(brand)" class="border-t border-gray-100">
            <div
              *ngFor="let vehicle of getCarsByBrand(brand)"
              class="py-4 border-b border-gray-100 last:border-0"
            >
              <div class="flex flex-col gap-1.5">
                <!-- Main Model Name -->
                <div class="text-sm font-bold text-gray-800 leading-tight">
                  {{ vehicle.carModelName }} {{ vehicle.modelClass }}
                </div>

                <!-- Engine / Year Info -->
                <div
                  class="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500"
                >
                  <span *ngIf="vehicle.displacement">{{
                    vehicle.displacement
                  }}</span>
                  <span *ngIf="vehicle.modelYear">{{ vehicle.modelYear }}</span>
                  <span
                    *ngIf="vehicle.engineCode"
                    class="bg-gray-100 px-1.5 py-0.5 rounded text-gray-600"
                    >{{ vehicle.engineCode }}</span
                  >
                </div>

                <!-- Match Notes - Use same logic as PC -->
                <div class="text-xs text-gray-600 mt-1">
                  <!-- Matching Name - Use same logic as PC -->
                  <div
                    *ngIf="
                      !isFromAllMatchedCars &&
                      partVOList[0]?.partDTO?.appDesList
                    "
                  >
                    <div
                      *ngFor="let appDes of partVOList[0].partDTO.appDesList"
                      class="mb-0.5"
                    >
                      {{ appDes }}
                    </div>
                  </div>
                  <div *ngIf="isFromAllMatchedCars && vehicle.appDesList">
                    <div
                      *ngFor="let appDes of vehicle.appDesList"
                      class="mb-0.5"
                    >
                      {{ appDes }}
                    </div>
                  </div>
                  <!-- Remarks - Use same logic as PC -->
                  <div class="text-xs mt-1">
                    <a
                      *ngIf="
                        hasVideoUrl(
                          vehicle.categoryName,
                          vehicle.remarkExternal
                        )
                      "
                      (click)="
                        openVideoModal(
                          vehicle.categoryName,
                          vehicle.remarkExternal
                        )
                      "
                      class="text-primaryBlue cursor-pointer flex items-center gap-1"
                    >
                      <span>{{
                        getRemarks(vehicle.remarkExternal, vehicle.categoryName)
                      }}</span>
                      <i
                        nz-icon
                        nzType="video-camera"
                        nzTheme="outline"
                        class="text-sm"
                      ></i>
                    </a>
                    <span
                      *ngIf="
                        !isVideoModal(vehicle.remarkExternal) &&
                        vehicle.remarkExternal
                      "
                      class="text-gray-600"
                      >{{ vehicle.remarkExternal }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="getFirst5Cars().length === 0"
          class="py-10 text-center text-gray-400 text-sm"
        >
          暂无适配车型数据
        </div>
      </div>

      <!-- Tab 2: Original Factory (Clean List) -->
      <div *ngIf="activeTab === 2" class="animate-fade-in">
        <div class="divide-y divide-gray-100">
          <div
            *ngFor="let factory of productData?.partOriginFactoryList"
            class="py-4"
          >
            <div class="font-bold text-sm text-gray-900 mb-2">
              {{ factory?.factoryBrandCn }}
            </div>
            <div class="flex flex-wrap gap-2">
              <span
                *ngFor="let num of factory?.factoryNames"
                class="text-xs bg-gray-50 text-gray-600 px-2 py-1 rounded border border-gray-100"
              >
                {{ num }}
              </span>
            </div>
          </div>
        </div>
        <div
          *ngIf="!productData?.partOriginFactoryList?.length"
          class="py-10 text-center text-gray-400 text-sm"
        >
          暂无原厂信息
        </div>
      </div>

      <!-- Other Tabs placeholders -->
      <div
        *ngIf="activeTab === 3 || activeTab === 4"
        class="py-10 text-center text-gray-400 text-sm"
      >
        暂无内容
      </div>
    </div>
  </nz-spin>

  <!-- Error Report Modal (Unchanged logic, just ensure styling) -->
  <nz-modal
    [(nzVisible)]="isErrorReportVisible"
    nzTitle="匹配报错"
    (nzOnCancel)="handleErrorReportCancel()"
    [nzFooter]="modalFooter"
  >
    <ng-container *nzModalContent>
      <!-- Form Content (Same as before) -->
      <form nz-form [formGroup]="errorReportForm">
        <!-- ... Keep existing form fields ... -->
        <nz-form-item>
          <nz-form-label class="error-report-label" [nzRequired]="true">联系方式</nz-form-label>
          <nz-form-control nzErrorTip="请输入联系方式">
            <input class="bosch_input" nz-input formControlName="contactInfo" placeholder="手机号/邮箱" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="error-report-label" [nzRequired]="true">请求主题</nz-form-label>
          <nz-form-control>
            <nz-select formControlName="subjectType">
              <nz-option nzValue="01" nzLabel="匹配报错"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="error-report-label" [nzRequired]="true">您的问题</nz-form-label>
          <nz-form-control nzErrorTip="请输入问题描述（最多500字）">
            <textarea nz-input formControlName="content" [nzRows]="4" class="bosch_textarea"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="error-report-label">报错车型</nz-form-label>
          <nz-form-control>
            <!-- <input nz-input formControlName="carIds" placeholder="报错车型" class="bosch_input" /> -->
            <nz-select nzMode="multiple" nzAllowClear nzPlaceHolder="请选择报错车型" formControlName="carIds">
              <nz-option *ngFor="let item of carIdOptions" [nzLabel]="item" [nzValue]="item">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="error-report-label"> 备注</nz-form-label>
          <nz-form-control nzErrorTip="请输入备注（最多500字）">
            <textarea nz-input formControlName="remark" placeholder="请输入备注" [nzRows]="3" class="bosch_textarea"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="error-report-label">添加图片</nz-form-label>
          <nz-form-control>
            <nz-upload class="w-[150px] h-[150px]" [nzBeforeUpload]="beforeUpload" [nzFileList]="fileList"
              [nzRemove]="removeFile" nzListType="picture" [nzLimit]="1">
              <div class="w-[150px] h-[150px] border border-dashed border-[#d9d9d9] flex-center flex-col"
                *ngIf="fileList.length < 1">
                <i nz-icon nzType="inbox" class="text-[#d9d9d9] text-[24px]"></i>
                <p class="!mt-4">点击上传图片</p>
              </div>
            </nz-upload>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <label class="error-report-checkbox" nz-checkbox formControlName="agreeToPolicy">
              我已阅读并同意相关的 <li class="privacy-link" (click)="handleViewPrivacy('/myAccount/data-protection-policy', 1)">隐私条款</li>
            </label>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
    <ng-template #modalFooter>
      <button nz-button (click)="handleErrorReportCancel()">取消</button>
      <button
        nz-button
        nzType="primary"
        (click)="handleErrorReportSubmit()"
      >
        提交
      </button>
    </ng-template>
  </nz-modal>

  <!-- Bottom Action Bar (Fixed) -->
  <div
    class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300 shadow-lg z-50"
    *ngIf="productData && isLogin"
  >
    <div class="flex items-center justify-between px-4 py-3">
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <span class="text-sm text-[#979EA4] whitespace-nowrap">
          {{ "MOQ" | translate }}:
          <span>{{ getMoq() }}</span>
        </span>
        <div
          *ngIf="
            productData?.stockQty !== null &&
            productData?.stockQty !== undefined
          "
          class="flex items-center gap-1 whitespace-nowrap"
        >
          <span class="text-sm text-[#000]">{{ "STOCK" | translate }}:</span>
          <svg-icon
            [iconName]="
              productData?.stockQty === 0
                ? 'new/red.svg'
                : (productData?.quantity || getMoq()) <= productData?.stockQty!
                ? 'new/green.svg'
                : 'new/yellow.svg'
            "
            [size]="16"
          ></svg-icon>
        </div>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0">
        <quantity-input
          class="mobile-qty-input"
          mode="list"
          [(quantity)]="productData.quantity"
          (quantityBlur)="quantityBlur($event)"
          (quantityChange)="quantityChange($event)"
        ></quantity-input>
        <button
          nz-button
          nzType="primary"
          class="mobile-add-cart-btn"
          (click)="openCartBottom()"
        >
          {{ "ADD_TO_CART_MOBILE" | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Cart Drawer -->
  <app-mobile-product-cart-bottom
    *ngIf="productData"
    [productData]="productData"
    [(visible)]="isCartBottomVisible"
  ></app-mobile-product-cart-bottom>
</div>
